module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape_item_1-fa8352dbe22ecfc026da2dbd25925c12.png";